import { useParams } from 'react-router-dom';
import { Column } from 'react-rainbow-components';
import Table from 'components/Table';
import {
    Section,
    SectionContent,
} from '../styled';
import ChannelNameColumn from './ChannelNameColumn';
import ChannelDeliveryColumn from './ChannelDeliveryColumn';

const channels = [
    { id: 'facebook', name: 'Facebook', icon: 'facebook' },
    { id: 'instagram', name: 'Instagram', icon: 'instagram' },
    { id: 'whatsapp', name: 'WhatsApp', icon: 'whatsapp' },
    { id: 'tiktok', name: 'TikTok', icon: 'tiktok' },
    { id: 'telegram', name: 'Telegram', icon: 'telegram' },
];

const ChannelDeliverySection = () => {
    const { agentId = '' } = useParams();

    return (
        <Section>
            <SectionContent>
                <Table keyField="id" data={channels}>
                    <Column
                        header="Channel"
                        field="name"
                        component={ChannelNameColumn}
                    />
                    <Column
                        header="Send Messages Through"
                        component={ChannelDeliveryColumn}
                        width={280}
                        agentId={agentId}
                    />
                </Table>
            </SectionContent>
        </Section>
    );
};

export default ChannelDeliverySection;
